import React, { useEffect } from "react";
import styles from './DetalleTramiteView.module.scss';
import { useDispatch } from "react-redux";
import Axios from 'services/BackendApi/BackendApi';
import ApiURLs from "services/BackendApi/BackendApiURLs";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DossierDataTable from "./DossierDataTable/DossierDataTable";
import { useParams } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";
import { SkipBackward } from "react-bootstrap-icons";
import { Modal } from "react-bootstrap";
import { TrashFill } from "react-bootstrap-icons";
import CheckMarkSuccess from "common/components/AnimatedIcons/CheckMarkSuccess/CheckMarkSuccess";
import ErrorMark from "common/components/AnimatedIcons/ErrorMark/ErrorMark";
import { Download } from "react-bootstrap-icons";
import { retrieveCatalogs } from "modules/bussiness_logic/actions/catalogActions";
import FileViewer from "common/components/FileViewer/FileViewer";
import { FiletypeXml } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { formatCurrency } from "common/helpers/DataFormat";
import { useSearchParams } from "react-router-dom";
import IndividualFileDownloader from "common/components/IndividualFileDownloader/IndividualFileDownloader";
import { CloudArrowDown } from "react-bootstrap-icons";

export default function DetalleTramiteView(props) {
	const [searchParams, setSearchParams] = useSearchParams();
	const initialValueShow = searchParams.get("show");
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const {dossierID} = useParams();
	const [dossierData, setDossierData] = useState({loading:true,data:[]});
	const [deleteDossier, setDeleteDossier] = useState({dialog:false,tx:0});
	const [txDataError, setTxDataError] = useState([]);
	const [filePreview, setFilePreview] = useState({display:false,title:'',id:null,type:null});

	const [downloadDocuments, setDownloadDocuments] = useState({display:(initialValueShow==="retenciones"), documents:[]});

	async function confirmDelete(){
		setDeleteDossier({...deleteDossier,tx:1})
		try {
			const { data } = await  Axios.EliminarTramite({dossier_id: dossierID});
			if (data.error){
			   //console.log('Error,',data);
			   setDeleteDossier({dialog:true,tx:3})
			   setTxDataError(data.error_log);
			}
			if (data.result && !data.error){
				setDeleteDossier({dialog:true,tx:2})
			}
		}catch (error){
			setDeleteDossier({dialog:false,tx:0})
		}
	}

	async function processTx(){
       		  try {
                const { data } = await  Axios.DetalleDossier({dossier: dossierID});
                if (data.error){
                   //console.log('Error,',data);
                }
                if (data.result && !data.error){
                    //console.log('Good',data);
					let docsInfo = [];
					let docsMd = [];
					let dossierMd = {};
					let dossierLot  = {}
					data.query_result[1].result.forEach(
						element => {

								let fieldValue = null;

								switch (element.dossier_metadata_type){
									case "string":{
										fieldValue = element.string_value;
									}break;
									case "boolean":{
										fieldValue = (element.boolean_value==1)? true: false;
									}break;
									case "date":{
										fieldValue = element.date_value;
									}break;
									case "blob":{
										fieldValue = element.blob_value;
									}break;
									case "integer": case  "int":{
										fieldValue = element.int_value;
									}break;
									case "currency": {
										fieldValue = (typeof(element.currency_value)=="string")? parseFloat(element.currency_value): element.currency_value;
									} break;
									case "percentage": {
										fieldValue = element.percentage_value;
									} break;
									case "timestamp": {
										fieldValue = element.timestamp_value;
									} break;
								}
								
								if (typeof(dossierMd[element.dossier_metadata_code])=="undefined"){ 
									if (element.dossier_metadata_code=="DOSSIER_NO_HOJA_ENTRADA"){
										dossierMd[element.dossier_metadata_code]=[{
											"key" : element.dossier_metadata_code,
											"label" : element.dossier_metadata_label,
											"value" : fieldValue
										}];
									}else{
										dossierMd[element.dossier_metadata_code]={
											"key" : element.dossier_metadata_code,
											"label" : element.dossier_metadata_label,
											"value" : fieldValue
										};
										//dossierMd[element.dossier_metadata_code]={};
									}
								}else{
									if (element.dossier_metadata_code=="DOSSIER_NO_HOJA_ENTRADA"){
										dossierMd[element.dossier_metadata_code][dossierMd[element.dossier_metadata_code].length]={
											"key" : element.dossier_metadata_code,
											"label" : element.dossier_metadata_label,
											"value" : fieldValue
										};
									}else{
										dossierMd[element.dossier_metadata_code]={
											"key" : element.dossier_metadata_code,
											"label" : element.dossier_metadata_label,
											"value" : fieldValue
										};
										//dossierMd[element.dossier_metadata_code]={};
									}
								}
								
								
							}
						
					);
					//console.log('dossier MD', dossierMd);
					data.query_result[3].result.forEach(
						element => {

								let fieldValue = null;

								switch (element.document_metadata_type){
									case "string":{
										fieldValue = element.string_value;
									}break;
									case "boolean":{
										fieldValue = (element.boolean_value==1)? true: false;
									}break;
									case "date":{
										fieldValue = element.date_value;
									}break;
									case "blob":{
										fieldValue = element.blob_value;
									}break;
									case "integer": case  "int":{
										fieldValue = element.int_value;
									}break;
									case "currency": {
										fieldValue = (typeof(element.currency_value)=="string")? parseFloat(element.currency_value): element.currency_value;
									} break;
									case "percentage": {
										fieldValue = element.percentage_value;
									} break;
									case "timestamp": {
										fieldValue = element.timestamp_value;
									} break;
								}
								let posMd = element.document;
								if (typeof(docsMd[posMd])=="undefined") docsMd[posMd]={}; 
								
								docsMd[posMd][element.document_metadata_code]={
									"key" : element.document_metadata_code,
									"label" : element.document_metadata_label,
									"value" : fieldValue
								};
							}
						
					);

					
					data.query_result[2].result.forEach(
						element => {
								docsInfo[docsInfo.length] = {
									...element,
									'metadata': (undefined !== docsMd[element.id])?docsMd[element.id]: {}
								};
								
							}
						
					)
					if (data.query_result[4].result.length>0){
						dossierLot = data.query_result[4].result[0];
					}

					//console.log('docs Info', docsInfo);
					let toStore = data.query_result[0].result[0];
					toStore['metadata'] = dossierMd;
					toStore['documents'] = docsInfo;
					
					toStore['lot'] = dossierLot;
					//console.log('To store:',toStore);
					setDossierData({loading:false,data:toStore});
                }	
            }catch(error){
               
				//console.log('catch Error',error);
            }
        
    }
	useEffect(() => {
		//dispatch(tramitePago());
		//dispatch(getDossierStatus());
		dispatch(retrieveCatalogs());
		processTx();
	}, [dispatch]);

	function switchModalContent(){
		switch (deleteDossier.tx){
			case 0:{return "OJO!: Esta acción NO PUEDE SER REVERTIDA.";}break;
			case 1:{return <div>
				Procediendo con la eliminación...
			</div>;}break;
			case 2:{return <div>
				<CheckMarkSuccess />
				<h3>El trámite ha sido eliminado con éxito!</h3>
			</div>;}break;
			case 3:{
				return <div>
					<ErrorMark />
						<h3>Hubo un error al eliminar este trámite </h3>
						<h4>Los errores detectados fueron:</h4>
						<ul>
							{txDataError.map((error_msg,idx)=>{
								return <li key={idx}>{error_msg}</li>;
							})}
						</ul>
				</div>;
			}break;
		}
	}
	function displayButtonCallback(docMime,payload){
		setFilePreview({
			display:true,
			id: payload.file,
			title: payload.document_type_label,
			type: (payload.type==2)?"xml":"pdf"
		});
	}

	if (dossierData.loading===true)
		return (<div>Cargando ...</div>);

	return (
		<div className={styles.container}>
			{
				(downloadDocuments.display===true)?
						<Modal show={downloadDocuments.display} onHide={()=>{setDownloadDocuments({...downloadDocuments,display:false})}}  backdrop="static" keyboard={false}>
							<Modal.Header closeButton={true}>
								<Modal.Title>Descargar Contraseña y/o Retenciones</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								{
									(undefined!==dossierData.data.documents)?
									dossierData.data.documents.map((doc,idx)=>{
										
										if 
										(
											(
												doc.type ==20
											)
										)
										{
											return <div className={styles.downloadbox}>
												<h4 className={styles.doctitle}>{doc.document_type_label}</h4>
												Descargue su contraseña acá <IndividualFileDownloader dossier={dossierData.data.id} file={doc.file} linkcontent={<Button variant="primary"><CloudArrowDown /> Descargar</Button>} />
											</div>;
										}
										else
										return "";

									}):''
								}
								{
									(undefined!==dossierData.data.documents)?
									dossierData.data.documents.map((doc,idx)=>{
										
										if 
										(
											(
												doc.type ==18
											)
										)
										{
											return <div className={styles.downloadbox}>
												<h4 className={styles.doctitle}>{doc.document_type_label}</h4>
												Descargue su retención de IVA acá <IndividualFileDownloader dossier={dossierData.data.id} file={doc.file} linkcontent={<Button variant="primary"><CloudArrowDown /> Descargar</Button>} />
											</div>;
										}
										else
										return "";

									}):''
								}
								{
						
									(undefined!==dossierData.data.documents)?
										dossierData.data.documents.map((doc,idx)=>{
											
											if 
											(
												(
													doc.type ==1
												)
												||
												(
													doc.type==3
												)
												||
												(
													doc.type == 17
												)
					
											)
											{
												let factXML = dossierData.data.documents.filter((item, index)=>
													((item.type == 2)&&(item.section === doc.section))
												);
												let retenIVA = dossierData.data.documents.filter((item, index)=>
													((item.type == 18)&&(item.section === doc.section))
												);
												let retenISR = dossierData.data.documents.filter((item, index)=>
													((item.type == 19)&&(item.section === doc.section))
												);

											return  <div className={styles.downloadbox}>
														
															<Container key={idx} className={styles.onedoc}>
																<Row>
																	<Col>
																		<h4 className={styles.doctitle}>{doc.document_type_label}</h4>
																	</Col>
																	<Col>
																
																	{
																		(((doc.type===1)||(doc.type===3))&&(dossierData.data.status>=250))?
																			<div>
																				
																				&nbsp;
																				{
																					retenISR.map((fitem,idx)=>{
																						return <IndividualFileDownloader dossier={dossierData.data.id} file={fitem.file} linkcontent={<Button variant="primary"><CloudArrowDown /> Descargar Retención ISR</Button>} />;
																					})
																				}
																			</div>
																		:" ... "
																	}</Col>
																</Row>
																<Row>
																	<Col className={styles.labeldata} xs={2}>
																		{doc.metadata.DOCUMENT_DATE.label}:
																	</Col>
																	<Col>
																		{doc.metadata.DOCUMENT_DATE.value}
																	</Col>
																</Row>
																<Row>
																	<Col className={styles.labeldata} xs={2}>Serie y Número:</Col>
																	<Col>{doc.serie}-{doc.numero}</Col>
																</Row>
																<Row>
																	<Col className={styles.labeldata} xs={2}>{
																		doc.metadata.DOCUMENT_MONTO.label
																	}:
																	</Col>
																	<Col>{formatCurrency(doc.metadata.DOCUMENT_CURRENCY.value,doc.metadata.DOCUMENT_MONTO.value)}</Col>
																</Row>
																<Row>
																	<Col className={styles.labeldata} xs={2}>{doc.metadata.DOCUMENT_DESCRIPCION.label}</Col>
																	<Col><div>{doc.description}</div></Col>
																</Row>
																
															</Container>
													</div>;
											}else{
												return;
											}
										}):'Loading...'
								}
							</Modal.Body><Modal.Footer>
							
                                    <Button variant="secondary" onClick={()=>{setDownloadDocuments({...downloadDocuments,display:false})}}>
                                        Regresar
                                    </Button>
                            </Modal.Footer>
						</Modal>:""
			}
			{
				(deleteDossier.dialog)? 
				
							
						<Modal show={deleteDossier.dialog} onHide={()=>{setDeleteDossier({dialog:false,tx:0});}}  backdrop="static" keyboard={false}>
							<Modal.Header closeButton={deleteDossier.tx==3}>
								<Modal.Title>¿Está seguro de Eliminar el trámite No. {dossierData.data.id} - "{dossierData.data.name}"</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								{
									switchModalContent()
								}
							</Modal.Body><Modal.Footer>
							{ (deleteDossier.tx==0)?
									<div>
                                    <Button variant="secondary" onClick={()=>{setDeleteDossier({dialog:false,tx:0})}}>
                                        Regresar
                                    </Button>
                                    <Button variant="danger" onClick={()=>{confirmDelete()}}>
                                        Sí, eliminar
                                    </Button>
                           </div>: 
						   		(deleteDossier.tx==2)?
								   <Button variant="secondary" onClick={()=>{ navigate("/digitalizacion/pendientes",true)}}>
								   		Finalizar
							   		</Button>:''
							} </Modal.Footer>
						</Modal>
						
				:''
			}
			{
				(true===filePreview.display)?
					<Modal show={filePreview.display} onHide={()=>{setFilePreview({display:false,title:'',id:null,type:null});}}  backdrop="static" keyboard={true}>
						<Modal.Header closeButton={deleteDossier.tx==3}>
							<Modal.Title>{filePreview.title}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
						<div className={styles.fileviewbodymodal}>
							<FileViewer variant={(filePreview.type=="pdf")?"view":"download"} file={filePreview.id} openingLabel={(filePreview.type=="pdf")?"Accediendo al archivo...":<Button onClick={(event)=>{setFilePreview({display:false,id:null, title:'',type:''})}} className={styles.downloadxmlbutton}>Descargar XML <FiletypeXml /> <Download /></Button>}  />
						</div>
						</Modal.Body>
						<Modal.Footer>
								<IndividualFileDownloader dossier={dossierData.data.id} file={filePreview.id} linkcontent={<Button variant="primary"><CloudArrowDown /> Descargar</Button>} />
								<Button variant="secondary" onClick={()=>{setFilePreview({display:false,title:'',id:null,type:null});}}>
									Cerrar
								</Button>
						 </Modal.Footer>
				</Modal>:''
			}
            <div className={styles.buttonbar}>
				{/*<Link to={(dossierData.data.status!==1000)?"/en-proceso":'/ya-pagados'} className="btn btn-primary">
					<SkipBackward /> Regresar
                </Link>*/}
				<Button onClick={() => navigate(-1)}><SkipBackward /> Regresar</Button> &nbsp;
				{
					(dossierData.data.status==20)?
					 	((dossierData.data.type==2)||(dossierData.data.type==4))?
							<Button variant="danger" disabled={dossierData.data.status==1} onClick={() => setDeleteDossier({dialog:true,tx:0})}><TrashFill /> Eliminar</Button>
							:
							""
					:
					""
				}
				
			</div>
			{
				(dossierData.loading)? "Cargando detalle...": <DossierDataTable data={dossierData.data} onButtonCallBack={displayButtonCallback} />
			}
			
		</div>
	);
}
